import { useContext, useState } from "react"
import { GamesContext } from "../Context/GamesContext"
import { Card, Button, List, Modal, Row, Col} from "antd"
import { UserContext } from "../Context/UserContext";

const Games = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [listGame] = useContext(GamesContext)
    const [ currentGame, setCurrentGame] = useState("")
    const [,,,,,setKeyMenu] = useContext(UserContext)

    setKeyMenu("/games")
    // console.log(keyMenu)

    const showModal = (id) => {
        let game = listGame.filter((el) => el.id === id)
        setCurrentGame(game)
        setIsModalOpen(true);
      };
    
      const handleOk = () => {
        setIsModalOpen(false);
      };
    
      const handleCancel = () => {
        setIsModalOpen(false);
      };

    // console.log(currentGame)
    return (
        <div style={{marginTop: "100px"}}>
            <List 
                pagination={{
                    pageSize: 9 
                  }}
                grid = {{ column: 3}}
                dataSource={listGame}
                renderItem={el => { 
                   
                    return (
                        <List.Item>
                            <Card hoverable="true" key={el.id}>
                                <img src={el.image_url} alt="banner-game"></img>
                                <h1>{el.name}</h1>
                                <Button type="primary" onClick={() => showModal(el.id)}>Detail</Button>
                                <Modal title={currentGame[0]?.name} open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={null}>
                                    <div>
                                        <img src={currentGame[0]?.image_url} alt="banner-game" style={{height: "300px"}}></img>
                                        <Row>
                                            <Col className="isi-modal">
                                                <p>{`Genre: ${currentGame[0]?.genre}`}</p>
                                                <p>{`Release: ${currentGame[0]?.release}`}</p>
                                                <p>{`Platform: ${currentGame[0]?.platform}`}</p>
                                                <p>Single Player: {currentGame[0]?.singlePlayer === 0 ? "No" : "Yes"}</p>
                                                <p>Multi Player: {currentGame[0]?.multiPlayer === 0 ? "No" : "Yes"}</p>
                                            </Col>
                                            
                                        </Row>
                                    </div>
                                    
                                </Modal>
                            </Card>
                           
                        </List.Item>
                      
                        )
                } }
            />
            
        </div>
        
    )
}

export default Games